import { Button } from '@mui/material';
import { fontStyles, sizeStyles } from './styles';
import PropTypes from 'prop-types';

const PrimaryTextButton = ({ text, onClick, className = '', isDisabled = false, isLoading = false, size = 'medium', icon }) => {
    return (
        <Button
            variant="text"
            className={className}
            disabled={isDisabled}
            onClick={onClick}
            {...(isLoading ? { loading: true } : {})}
            sx={{
                color: '#1870eb',
                width: 'auto',
                textTransform: 'none',
                ...sizeStyles[size],
                ...fontStyles[size],
            }}
        >
            {icon && icon}
            {text}
        </Button>
    );
};

PrimaryTextButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    icon: PropTypes.node,
};

export default PrimaryTextButton;
